import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const selectors = {
  header: '.js-header:not(.is-initialized)',
  menu: '.js-header-menu',
  open: '.js-header-open',
  close: '.js-header-close',
  menuList: '.js-header-menu-list',
  panelTrigger: '.js-header-panel-trigger',
  panel: '.js-header-panel',
};

const classes = {
  sticky: 'is-sticky',
  open: 'is-open',
  hidden: 'is-hidden',
  panelOpen: 'has-panel-open',
  menuOpen: 'has-menu-open',
};

let resizeTimeout;

const getNavHeight = (header) => {
  clearTimeout(resizeTimeout);

  resizeTimeout = setTimeout(() => {
    const navHeight = header.clientHeight;
    document.documentElement.style.setProperty('--navH', `${navHeight}px`);
  }, 100);
};

const onResize = (header) => {
  getNavHeight(header);
};

const toggleMenu = (menu, toggle, menuList, header, isOpen) => {
  menu.classList.toggle(classes.open, isOpen);
  header.classList.toggle(classes.menuOpen, isOpen);
  if (isOpen) {
    menuList.hidden = false;
  }
  toggle.setAttribute('aria-expanded', isOpen);

  requestAnimationFrame(() => {
    menuList.classList.toggle(classes.hidden, !isOpen);

    setTimeout(() => {
      if (!isOpen) {
        menuList.hidden = true;
      }
    }, 300);
  });
};

const showHideNav = header => {
  const navTrigger =
    document.querySelector(selectors.navTrigger) ?? document.body;
  gsap.to(header, {
    scrollTrigger: {
      id: 'navTrigger',
      trigger: navTrigger,
      start: '5px top',
      end: 'max',
      onEnter: () => {
        header.classList.add(classes.sticky);
      },
      onLeaveBack: () => {
        header.classList.remove(classes.sticky);
      },
    },
  });
};

const togglePanel = (panel, trigger, header, isOpen) => {
  if (!panel) return;

  panel.classList.toggle(classes.open, isOpen);
  trigger.setAttribute('aria-expanded', isOpen);
  header.classList.toggle(classes.panelOpen, isOpen);
  panel.hidden = !isOpen;

  if (isOpen) {
    const panelHeight = panel.clientHeight;
    const navHeight = header.clientHeight;
    document.documentElement.style.setProperty('--navFullH', `${navHeight + panelHeight}px`);

    setTimeout(() => {
      document.documentElement.style.setProperty('--navFullH', `${navHeight + panelHeight}px`);
    }, 600);
  }
};

const init = () => {
  const header = document.querySelector(selectors.header);

  if (!header) return;

  header.classList.add('is-initialized');

  const panelTriggers = header.querySelectorAll(selectors.panelTrigger);
  const panels = header.querySelectorAll(selectors.panel);

  panelTriggers.forEach(trigger => {
    trigger.addEventListener('mouseenter', () => {
      const panelId = trigger.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      if (!panel) return;
      const isOpen = true;
      togglePanel(panel, trigger, header, isOpen);
    });
  });

  panels.forEach(panel => {
    panel.addEventListener('mouseleave', () => {
      const trigger = header.querySelector(`[aria-controls="${panel.id}"]`);
      if (!trigger) return;
      const isOpen = false;
      togglePanel(panel, trigger, header, isOpen);
    });
  });

  setTimeout(() => {
    onResize(header);
  }, 100);
  window.addEventListener('resize', () => {
    onResize(header);
  });

  showHideNav(header);

  const menu = header.querySelector(selectors.menu);
  const open = header.querySelector(selectors.open);
  const close = header.querySelector(selectors.close);
  const menuList = header.querySelector(selectors.menuList);
  if (!menu || !open || !close || !menuList) return;

  menuList.style.setProperty('--h', `${menuList.clientHeight}px`);
  menuList.hidden = true;
  menuList.classList.add(classes.hidden);

  open.addEventListener('click', () => {
    toggleMenu(menu, open, menuList, header, true);
  });

  close.addEventListener('click', () => {
    toggleMenu(menu, close, menuList, header, false);
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
